import React from "react";
import classNames from "classnames";
import Element from "../Element";
import TooltipIcon from "../../_common/TooltipIcon";
import FieldI from "../../../interfaces/FieldInternal";
import { translateLabel } from "../../../custom/utils/translateForm";
import i18n from "../../../i18n";

const Field = ({
  description,
  disabled,
  error,
  label,
  labelClassName,
  printError = true,
  printFormRow = true,
  render,
  tooltip,
  validate,
  ui,
  id,
  ...restProps
}: FieldI) => {
  const newRenderFunc = (props: any) => {
    if (printFormRow === false) {
      return render({ ...props, ui });
    }
    const newLabel = translateLabel(id, label as string);
    return (
      <div
        className={classNames("form-row", ui.attributes?.classNames?.wrapper)}
      >
        <div
          className={classNames("form-row__label", { "has-error": !!error })}
        >
          {newLabel && (
            <>
              <div className={labelClassName}>
                {validate?.required && (
                  <>
                    <span className="text-danger form-row__label-asterix" title={i18n.t('global.required')}>
                      *
                    </span>{" "}
                  </>
                )}
                <span dangerouslySetInnerHTML={{ __html: newLabel }} />
              </div>
              {tooltip && !disabled && (
                <div>
                  <TooltipIcon
                    className="icon-circle--small"
                    tooltip={tooltip}
                  />
                </div>
              )}
            </>
          )}
        </div>
        <div className="form-row__input">{render({ ...props, ui })}</div>
        <div className="form-row__error">
          {error && printError && (
            <div className="invalid-feedback">{i18n.t(error)}</div>
          )}
        </div>
        <div className="form-row__description">
          {description && (
            <small className="form-text text-muted">{description}</small>
          )}
        </div>
      </div>
    );
  };

  return (
    <Element render={newRenderFunc.bind(restProps)} ui={ui} {...restProps} />
  );
};

Field.defaultProps = {
  custom: false,
  disabled: false,
};

export default Field;
